var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        fill: "none"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M0 4a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4z",
          fill: "#ffa89d"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M16.046 6.537c-.091 0-.091-.046 0 0h0zm-.138.64c.046.046.137.046.183.091-.046-.046-.137-.091-.183-.091z",
          fill: "#7fdecb"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M16 5c-3.827 0-7 3.055-7 6.839 0 2.873 3.687 10.487 5.693 14.408.513 1.003 2.007 1.003 2.567 0C19.267 22.235 23 14.575 23 11.794 23 8.055 19.873 5 16 5z",
          fill: "#ffe252"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M12.134 12.462c.167 1.851 2.008 3.837 3.983 3.5.033-.034 1.975-.067 2.075-.673.301-.067.603-.438.803-.673.669-.538 1.004-1.952 1.004-3.097-.034.067-.034.034-.034-.034-.268-.606-.971-2.356-2.243-2.827.067 0-.067-.067-.033 0-.034-.034-.067-.034-.1-.067.1 0 .134-.269-.067-.202.201.135.034.135-.034.034-.335.236-1.372-.438-.535-.135l-.034-.034c.167.034.435 0 .335-.101.034.101-.301-.067-.201.034-.1-.101-.167-.135-.335-.135.167.135-.569.034-.301-.034-.937-.101-2.176.202-2.778.841-.268.101-.368.438-.603.505.033 0 .033 0 .067-.034-.234.135-.402.976-.602.875-.167.471-.435 1.582-.502 1.851.034.202.301.539.134.404zm5.891 3.029c.034-.034.034-.034 0 0zm-4.619-5.284c0 .034-.034.067-.067.101 0-.034.034-.067.067-.101zm-.167.236c.067-.135.067.034 0 0 .034-.236.268.135.268-.135-.234.135 0-.034-.067-.202.167-.37.736-.539.335-.269-.034 0-.034.034-.067.067h.034c-.067.101-.1.337 0 .269-.1 0 .134-.168.034-.168.134-.034.167-.067.234-.135-.167 0 .234-.337.167-.135l.134-.135h-.033.033c.502-.337 1.439-.572 1.908-.572.201.101.435-.034.569.135l-.034-.034c.201 0 .268.135.569.067.067.101.368.101.201.202 1.774.841 2.109 3.433.636 4.813-.301.572-1.439.808-2.176.976-.234-.101-.569-.067-.77-.135-.502-.202-1.707-.774-1.874-1.683-.603-.168-.736-1.986-.1-2.928z",
          fill: "#02016f"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }